import Image from "next/image";
import { cn } from "@/lib/utils";

/** 1×1 white PNG — raster plate stays lighter under browser force-dark than CSS bg. */
const LIGHT_PLATE =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAADElEQVQI12P4//8/AAX+Av4NwOu/AAAAAElFTkSuQmCC";

export function BrandLogo({
  src,
  alt = "XL Law & Consulting",
  className,
  imageClassName,
  priority = false,
}: {
  src: string;
  alt?: string;
  className?: string;
  imageClassName?: string;
  priority?: boolean;
}) {
  return (
    <div
      className={cn(
        "relative inline-flex items-center justify-center overflow-hidden rounded-xl px-4 py-3",
        className
      )}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={LIGHT_PLATE}
        alt=""
        aria-hidden
        className="pointer-events-none absolute inset-0 h-full w-full object-cover"
      />
      <Image
        src={src}
        alt={alt}
        width={280}
        height={120}
        unoptimized
        priority={priority}
        className={cn(
          "relative z-10 h-16 w-auto object-contain sm:h-20",
          imageClassName
        )}
      />
    </div>
  );
}
